//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    deleteCheck:{
      type: Boolean,
      default: null
    }
  },
  methods: {
    removeSelect(){
      this.item.delete = true
      this.$emit('delete')
    },
    checkSelect(){
      this.item.delete = !this.item.delete
      this.$emit('check', this.item)
    }
  },
}
